import React, { Component } from 'react';
import { Bar, Line, Pie } from 'react-chartjs-2';

class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: props.chartData
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      chartData: props.chartData
    })
  }

  render() {
    if (!this.state.chartData || this.state.chartData.length === 0) {
      return null;
    }

    const { labelKey } = this.props;
    const { heatUnits } = this.props;
    const chartKey = labelKey === 'kWh' ? labelKey : heatUnits;
    
    const baseData = [];
    const modifiedData = [];
    const monthLabels = [];
    let totalBase = 0;
    let totalModified = 0;

    this.state.chartData.map(simEntry => {
      const baseVal = simEntry.base;
      const modifiedVal = simEntry.hideModified ? simEntry.base : simEntry.modified;
      monthLabels.push(simEntry.month);
      baseData.push(baseVal);
      modifiedData.push(modifiedVal);
      totalBase += baseVal;
      totalModified += modifiedVal;
      return simEntry;
    });

    const baseDataSet = {
      backgroundColor: "rgb(25,80,140",
      borderColor: "rgb(25,80,140)",
      fill: false,
      data: baseData,
      label: `Base (${totalBase} ${chartKey})`
    };

    const modifiedDataSet = {
      backgroundColor: "rgb(38,133,85",
      borderColor: "rgb(38,133,85)",
      fill: false,
      data: modifiedData,
      label: `Modified (${totalModified} ${chartKey})`
    };

    const data = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      // datasets: this.state.chartData.map((data, index) => {
      //   if (index === 1) {
      //     return {
      //       label: `Base (${data[12]}kWh)`,
      //       data: data.slice(0, 12),
      //       backgroundColor: "rgb(128,149,255)"
      //       //backgroundColor: 'yellow'
      //     }
      //   }
      //   return {
      //     label: `Modified (${data[12]}kWh)`,
      //     data: data.slice(0, 12),
      //     backgroundColor: "rgb(0,255,255)"
      //     //backgroundColor: 'red'
      //   }
      // })
      datasets: [baseDataSet, modifiedDataSet]
    }

    return (
      <div className="chart">
        <Line
          data={data}
          options={{
            legend: {
              display: true,
              labels: {
                fontColor: 'rgb(27,27,27)'
              }
            },
            title: {
              display: 'Title',
              text: `Results: ${this.props.building.siteName}`,
              fontSize: 25
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    // min: minRange,
                    // max: maxRange
                  }
                }
              ]
            }
          }}
        />
      </div>
    )
  }
}
export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart.js